<template>
  <div
    class="home_wrap"
    :style="all_game_list.length == 0 ? 'height:100vh' : ''"
  >
    <van-nav-bar
      title="Recente"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- 搜索 -->
    <div
      v-show="true"
      class="search-wrap"
    >
      <input
        v-model="keyword"
        class="input-keyword"
        type="text"
        placeholder="Pesquisar"
      >
      <van-icon
        name="search"
        class="simg"
      />
    </div>
    <div class="game-bg">
      <div
        id="game-left-bg"
        style="width: 25%"
      >
        <div v-if="show">
          <div
            class="game-left-item"
            :class="left_active == 0 ? 'nav_ac' : ''"
            @click="changeLeftNav(0)"
          >
            <div style="margin-top: .1rem;">
              <svg
                width="2em"
                height="2em"
                fill="#fff"
                style="width: inherit; height: inherit;"
                viewBox="0 0 100 76"
              >
                <g
                  id="Gb2DiTHb-icon_dtfl_zj_0"
                  transform="translate(981.811 -1516.597)"
                >
                  <rect
                    id="Gb2DiTHb-底板"
                    width="100"
                    height="76"
                    transform="translate(-981.811 1516.597)"
                    opacity="0"
                  />
                  <path
                    id="Gb2DiTHb-Union_199"
                    data-name="Union 199"
                    d="M5.1,41.576a3.452,3.452,0,0,1,2.174-4.832l.117-.035a3.492,3.492,0,0,1,4.067,1.863,21.9,21.9,0,1,0,1.306-21.582L15.6,16.74a3.516,3.516,0,0,1,.618,7L4.753,24.75c-.1.009-.205.013-.31.013a3.517,3.517,0,0,1-3.5-3.2l-.93-10.6a3.516,3.516,0,0,1,7-.616l.2,2.287A28.9,28.9,0,1,1,5.1,41.576Zm32.869-2.536L27.9,33.819A3.516,3.516,0,0,1,26,30.7V19.643a3.516,3.516,0,0,1,7.031,0v8.92L41.2,32.8a3.514,3.514,0,0,1-3.235,6.239Z"
                    transform="translate(-960.772 1526.597)"
                  />
                </g>

                <defs>
                  <linearGradient
                    id="006d0b72-bc41-4fd1-8869-63c70d147752"
                    x1="0.5000000000000001"
                    x2="0.4999999999999999"
                    y1="0"
                    y2="1"
                  >
                    <stop
                      key="0"
                      offset="0"
                      stop-color="var(--skin__leftnav_active)"
                    />
                    <stop
                      key="1"
                      offset="1"
                      stop-color="var(--skin__leftnav_active)"
                    />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <span class="ppl">Recente</span>
          </div>
        </div>
        <div v-else>
          <div
            class="game-left-item"
            :class="left_active == 0 ? 'nav_ac' : ''"
            @click="changeLeftNav(0)"
          >
            <i class="icon_box">
              <svg
                width="1em"
                height="1em"
                class=""
                style="width: inherit; height: inherit;"
                viewBox="0 0 100 76"
              >
                <g
                  id="67b7519b159e3424baa948d2fb83eb91-icon_dtfl_dz_0"
                  transform="translate(434.001 -8831)"
                >
                  <rect
                    id="67b7519b159e3424baa948d2fb83eb91-底板"
                    width="100"
                    height="76"
                    transform="translate(-434.001 8831)"
                    opacity="0"
                  />
                  <path
                    id="67b7519b159e3424baa948d2fb83eb91-Union_219"
                    data-name="Union 219"
                    d="M4.005,45a4,4,0,0,1-4-4V4a4,4,0,0,1,4-4H86a4,4,0,0,1,4,4V41a4,4,0,0,1-4,4ZM60,7V38a2,2,0,0,0,2,2h21a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2h-21A2,2,0,0,0,60,7Zm-27.5,0V38a2,2,0,0,0,2,2h21a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2h-21A2,2,0,0,0,32.505,7ZM5,7V38a2,2,0,0,0,2,2h21a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H7A2,2,0,0,0,5,7ZM65.674,33.626c-1.013-5.238,1.87-8.651,9.47-14.446a7.026,7.026,0,0,1-3.2-.555,6.3,6.3,0,0,0-3.154-.516,4.318,4.318,0,0,0-2.781,2.223H62.505V12.5h3.714c-.052.9.624.767,1.092.5a4.443,4.443,0,0,1,2.544-.424,33.446,33.446,0,0,1,4.028,1.058,13.338,13.338,0,0,0,4.677.583,4.684,4.684,0,0,0,3.169-1.35l2.027,2.342c-9.119,9.207-6.9,14.923-5.883,18.414Zm-27.5,0c-1.014-5.238,1.87-8.651,9.469-14.446a7.022,7.022,0,0,1-3.2-.555,6.3,6.3,0,0,0-3.155-.516,4.314,4.314,0,0,0-2.78,2.223H35V12.5h3.713c-.051.9.624.767,1.092.5a4.446,4.446,0,0,1,2.545-.424,33.474,33.474,0,0,1,4.027,1.058,13.338,13.338,0,0,0,4.677.583,4.684,4.684,0,0,0,3.169-1.35l2.027,2.342c-9.119,9.207-6.9,14.923-5.883,18.414Zm-27.5,0c-1.014-5.238,1.87-8.651,9.47-14.446a7.026,7.026,0,0,1-3.2-.555,6.3,6.3,0,0,0-3.155-.516,4.318,4.318,0,0,0-2.78,2.223H7.5V12.5h3.714c-.052.9.624.767,1.092.5a4.443,4.443,0,0,1,2.544-.424,33.49,33.49,0,0,1,4.027,1.058,13.335,13.335,0,0,0,4.677.583,4.684,4.684,0,0,0,3.169-1.35l2.026,2.342c-9.119,9.207-6.9,14.923-5.883,18.414Z"
                    transform="translate(-429.003 8846)"
                  />
                </g>

                <defs>
                  <linearGradient
                    id="db87bd94-35d3-4e53-aed0-8d10a6f0c424"
                    x1="0.5000000000000001"
                    x2="0.4999999999999999"
                    y1="0"
                    y2="1"
                  >
                    <stop
                      key="0"
                      offset="0"
                      stop-color="var(--skin__leftnav_active)"
                    />
                    <stop
                      key="1"
                      offset="1"
                      stop-color="var(--skin__leftnav_active)"
                    />
                  </linearGradient>
                </defs>
              </svg>
            </i>
            <!-- <img
              v-if="left_active == 0"
              class="nav_img"
              src="../../assets/images/category/777a.png"
            >
            <img
              v-else
              class="nav_img"
              src="../../assets/images/category/777.png"
            > -->
            <span class="ppl">slots</span>
          </div>
          <div
            class="game-left-item"
            :class="left_active == 1 ? 'nav_ac' : ''"
            @click="changeLeftNav(1)"
          >
            <img
              class="nav_img"
              src="../../assets/images/category/PGa.png"
            >
            <span class="ppl">PG</span>
          </div>
          <div
            class="game-left-item"
            :class="left_active == 2 ? 'nav_ac' : ''"
            @click="changeLeftNav(2)"
          >
            <img
              class="nav_img"
              src="../../assets/images/category/PPa.png"
            >
            <span class="ppl">PP</span>
          </div>
          <div
            class="game-left-item"
            :class="left_active == 3 ? 'nav_ac' : ''"
            @click="changeLeftNav(3)"
          >
            <img
              class="nav_img"
              src="../../assets/images/category/TADAa.png"
            >
            <span class="ppl">TADA</span>
          </div>
          <div
            class="game-left-item"
            :class="left_active == 4 ? 'nav_ac' : ''"
            @click="changeLeftNav(4)"
          >
            <img
              class="nav_img"
              src="../../assets/images/category/JDBa.png"
            >
            <span class="ppl">JDB</span>
          </div>
          <div
            class="game-left-item"
            :class="left_active == 5 ? 'nav_ac' : ''"
            @click="changeLeftNav(5)"
          >
            <img
              class="nav_img"
              src="../../assets/images/category/CPa.png"
            >
            <span class="ppl">CP</span>
          </div>
        </div>
      </div>
      <div id="game-right-bg">
        <div class="tab_nav">
          <van-tabs
            v-model="nav_active"
            class="van-tabs__wrap--scrollable"
            :sticky="false"
            :swipeable="true"
            :swipe-threshold="2"
            :background="'transparent'"
            :line-width="0"
            @change="tabChange"
          >
            <div v-if="show">
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">Tudo</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">Popular</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">Favoritos</span>
                  </div>
                </template>
              </van-tab>
            </div>
            <div v-else>
              <van-tab v-if="left_active !== 0">
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">Tudo</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">Popular</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">Recente</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">Favoritos</span>
                  </div>
                </template>
              </van-tab>
            </div>
          </van-tabs>
        </div>
        <div
          v-if="all_game_list.length == 0"
          class="nonew-list"
        >
          <img
            src="../../assets/images/category/noList.png"
            alt=""
          >
          <p>Nenhum jogo disponível</p>
        </div>
        <div
          v-for="(game, idx) in all_game_list"
          v-else
          :id="'game' + idx"
          :key="idx"
          class="new-list"
        >
          <div
            v-for="(game_t, tidx) in game"
            :key="tidx"
            class="new_box"
          >
            <div
              class="game-list"
              :style="{ height: screenHeight + 'px' }"
            >
              <div
                v-for="(item, index) in game_t"
                v-show="(currentPage - 1) * 30 <= index && currentPage * 30 > index"
                :key="index"
                class="subgame-item"
                @click="
                  playGame(item.game_id, item.origin, item.id, item.is_works)
                "
              >
                <img
                  v-if="colletIds.includes(item.id)"
                  class="like_icon"
                  src="../../assets/images/category/like_color.png"
                  alt=""
                  @click.stop="setFavoritos(item)"
                >
                <img
                  class="like_icon"
                  src="../../assets/images/category/like.png"
                  alt=""
                  @click.stop="setFavoritos(item)"
                >
                <div
                  v-lazy:background-image="item.img"
                  class="innerbox"
                  :class="idx + '_innerbox'"
                >
                  <img
                    v-if="!item.is_works"
                    src="../../assets/images/common/nowork.png"
                    class="nowork"
                  >
                  <div
                    v-if="item.origin != 'CP'"
                    class="subgame_item_pg_name"
                  >
                    {{ item.game_name }}
                  </div>
                </div>
              </div>
              <!-- <div
                v-show="game_t.length > step_show"
                class="show_more"
                @click="showMore(idx)"
              >
                <div>
                  A exibir {{ step_show }} jogos entre
                  {{ game_t.length }} Popular jogos
                </div>
                Mostre mais ⇊
              </div> -->
            </div>
          </div>
        </div>
        <!-- 分页栏 -->
        <div
          v-if="gameLength > 30"
          class="geme_page"
          style="
              position: fixed;
              bottom: 2%;
              left: 37%;
              right: 0;
              display: flex;
            "
        >
          <van-pagination
            v-model="currentPage"
            :items-per-page="30"
            :total-items="gameLength"
            @change="PageChange"
          >
            <template #prev-text>
              <van-icon name="arrow-left" />
            </template>
            <template #next-text>
              <van-icon name="arrow" />
            </template>
          </van-pagination>
        </div>
      </div>
    </div>
    <div
      v-show="show_game_box"
      id="bigBox"
      class="game-box"
    >
      <!--    <div class="game-box" id="bigBox" v-show="true">-->
      <!-- <iframe :src="game_url" frameborder="0" id="myiframe"></iframe> -->
      <div
        class="back_to_desk"
        @click="beforeCloseGame()"
      >
        <van-icon
          name="wap-home-o"
          class="close_game_btn"
        />
        <div style="font-size: 0.3rem">
          Sair
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar, Lazyload, Pagination, Tabs, Tab, Toast } from "vant";
import Fetch from "../../utils/fetch";
import Axios from "axios";
Vue.use(NavBar).use(Pagination).use(Tabs).use(Tab).use(Lazyload, {
  lazyComponent: true,
});
const collectStorageKey = "COLLET_LIST"

export default {
  name: "SubGame",
  components: {},
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      keyword: "",
      gamestile: "Slots",
      all_game_list: [],
      all_game_list_bak: [],
      page_game_list: [],
      nav_active: 0,
      perPage: 30,
      step_show: 28,
      max_show_array: [6, 6, 6, 6],
      currentPage: 1,
      category: "type",
      show_game_box: false,
      is_ban: 0,
      username: null,
      i: 0,
      pagecount: 30,
      left_active: 0,
      result: {},
      timer: false,
      screenHeight: "",
      flag: 0,
      show: true,
      oldList: [],
      colletList: []
    };
  },
  computed: {
    gameLength() {
      return this.all_game_list.slots ? Object.values(this.all_game_list.slots)[0].length : 0
    },
    colletIds() {
      return this.colletList.map(({ id }) => id)
    }
  },
  watch: {
    pagecount: function (newn, oldn) {
      // console.log(newn, oldn);
    },
    left_active() {
      this.currentPage = 1
    },
    screenHeight(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenHeight);
          that.timer = false;
        }, 400);
      }
    },

    keyword: function (newn) {
      if (newn == "") {
        this.all_game_list = this.all_game_list_bak;
        return;
      }
      this.all_game_list = { GAMES: { Resultados: [] } };
      let allGames = [];
      for (var k in this.all_game_list_bak) {
        //console.log(k);
        for (var t in this.all_game_list_bak[k]) {
          //console.log(t);
          this.all_game_list_bak[k][t].forEach((item) => {
            //console.log(item);
            if (item.game_name.toLowerCase().search(newn.toLowerCase()) != -1) {
              allGames.push(item);
            }
          });
        }
      }
      this.all_game_list = { GAMES: { Resultados: allGames } };
    },
  },
  created() {
    this.getUserInfo();
    this.getCollet();
    // let params = this.$route.query.gameId;
    if (this.$route.query.gameId) {
      this.show = false;
      this.getGanmeTypeList(this.$route.query.flag);
    } else {
      this.show = true;
      this.getGameList(this.flag);
    }
  },
  mounted() {
    window.screenHeight = document.body.clientHeight - 138;
    this.screenHeight = window.screenHeight;
    var that = this;
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight - 138;
        that.screenHeight = window.screenHeight;
        // console.log(that.screenHeight);
      })();
    };
  },
  methods: {
    getGanmeTypeList(flag) {
      Fetch("/Game/getNewGameList", {
        type: this.category,
      }).then((res) => {
        this.result = res.data.slots;
        this.all_game_list = {
          slots: {
            all: res.data.slots.all
          }
        }
        console.log(this.all_game_list, '===gamle')
        this.all_game_list_bak = {
          slots: {
            all: res.data.slots.all
          }
        }
        this.oldList = JSON.parse(JSON.stringify(this.result));
        if (this.$route.query.gameId && flag) {
          let type = this.$route.query.gameId;
          // this.category = this.$route.query.gameId;
          // this.nav_active = 0;
          let active = "";
          if (type == "PG") {
            active = 1;
          }
          if (type == "PP") {
            active = 2;
          }
          if (type == "TADA") {
            active = 3;
          }
          if (type == "JDB") {
            active = 4;
          }
          if (type == "CP") {
            active = 5;
          }
          this.changeLeftNav(active);
        }
        // this.all_game_list = res.data;
        // this.all_game_list_bak = res.data;
      });
    },
    PageChange(e) {
      console.log(e, 'e---');
      // this.all_game_list = [];
      // let allGames = [];
      // const startIndex = (this.currentPage - 1) * this.perPage;
      // const endIndex = startIndex + this.perPage;
      // if (this.nav_active == 0) {
      //     allGames = this.all_game_list_bak[0].game_list.concat(
      //         this.all_game_list_bak[1].game_list
      //     );
      //     //this.pagecount = Math.ceil(allGames.length / this.perPage);
      // } else if (this.nav_active == 1) {
      //     allGames = this.all_game_list_bak[0].game_list;
      // } else if (this.nav_active == 2) {
      //     allGames = this.all_game_list_bak[1].game_list;
      // }
      // const gameKeys = Object.keys(allGames);
      // let res = [];
      // for (let i = startIndex; i < endIndex && i < gameKeys.length; i++) {
      //     const key = gameKeys[i];
      //     const value = allGames[key];
      //     res.push(value);
      // }
      // this.all_game_list.push({
      //     origin: "Slots",
      //     game_list: res,
      // });
      // console.log(this.all_game_list);
    },
    beforeCloseGame() {
      document
        .getElementById("bigBox")
        .removeChild(document.getElementById("myiframe"));
      this.show_game_box = false;
      this.game_url = "";
      //重新获取用户的余额
      this.getUserInfo();
      // Fetch("/box/getTodaybetInfo", {}, false, true).then((r) => {
      //   this.todayInfo = r.data;
      //   this.$confirm(
      //     `Você apostou ${r.data.today_bet_amount} e completou ${
      //       r.data.percent
      //     }%, restando ${
      //       100 - r.data.percent
      //     }% para reivindicar bônus de apostas adicionais.`,
      //     {
      //       confirmButtonText: "Continuar o jogo",
      //       cancelButtonText: "Deixe o jogo",
      //       // type: 'warning',
      //       showClose: false,
      //       center: true,
      //     }
      //   )
      //     .then((e) => {
      //       console.log("用户选择了继续游戏...", e);
      //     })
      //     .catch((e) => {
      //       console.log(e);
      //     });
      // });
    },
    showMore(idx) {
      this.step_show += 28;
    },

    getCollet() {
      // Fetch("/game/collectList").then(res => {
      //     this.colletList = res.data
      //     if(this.left_active == 0 && this.nav_active == 2) {
      //         this.all_game_list = this.getListData('', this.colletList)
      //     }
      // })
      this.colletList = localStorage.getItem(collectStorageKey) ? JSON.parse(localStorage.getItem(collectStorageKey)) : []
      if (this.left_active == 0 && this.nav_active == 2) {
        this.all_game_list = this.getListData('', this.colletList)
      }
    },
    getGameList(flag) {
      Fetch("/game/gameType", {
        flag: flag,
      }, { method: "get" }).then((res) => {
        this.result = res.data;
        this.all_game_list = {
          recent: {
            all: res.data
          }
        }
        this.all_game_list_bak = {
          recent: {
            all: res.data
          }
        }
      });
    },
    changeLeftNav(idx) {
      // this.tabChange(idx);
      console.log(idx, '----')
      this.nav_active = 0;
      this.left_active = idx
      if (this.show) {
        if (idx == 0) {
          this.getGameList();
        }
      } else {
        if (idx == 0) {
          this.all_game_list = this.getListData("all");
          this.all_game_list_bak = this.getListData("all");
        }
        if (idx == 1) {
          this.all_game_list = this.getListData("PG");
          this.all_game_list_bak = this.getListData("PG");
        }
        if (idx == 2) {
          this.all_game_list = this.getListData("PP");
          this.all_game_list_bak = this.getListData("PP");
        }
        if (idx == 3) {
          this.all_game_list = this.getListData("TADA");
          this.all_game_list_bak = this.getListData("TADA");
        }
        if (idx == 4) {
          this.all_game_list = this.getListData("JDB");
          this.all_game_list_bak = this.getListData("JDB");
        }
        if (idx == 5) {
          this.all_game_list = this.getListData("CP");
          this.all_game_list_bak = this.getListData("CP");
        }
      }
      console.log(idx);
    },
    getListData(name, list) {
      console.log(name)
      return {
        slots: {
          name: list || this.oldList[name]
        }
      }
    },
    tabChange(v) {
      console.log(v, '===v==')
      this.nav_active = v;

      if (this.show) {
        console.log(1)
        if (v == 0) {
          this.flag = 0;
          this.getGameList(this.flag);
        } else if (v == 2) {
          this.all_game_list = this.getListData('', this.colletList)
        } else {
          // this.all_game_list = [];
          // this.all_game_list_bak = [];
          this.flag = 1;
          this.getGameList(this.flag);
        }
      } else {
        console.log(2)
        if (v !== 0) {
          console.log(3)
          if (this.left_active == 0) {
            if (this.nav_active == 2) {
              this.all_game_list = this.getListData('', this.colletList)
              return
            }
            this.getGameList(0);
          } else {
            this.left_active = 0;
            if (this.nav_active == 1) {
              this.nav_active = 0;
              this.getGanmeTypeList(false);
            } else if (this.nav_active == 2) {
              this.nav_active = 1;
              this.getGameList(0);
            } else if (this.nav_active == 3) {
              this.nav_active = 2
              this.all_game_list = this.getListData('', this.colletList)
            }
          }

        } else {
          this.all_game_list = this.getListData("all");
          this.all_game_list_bak = this.getListData("all");
        }
      }

    },
    getUserInfo() {
      Fetch("/user/is_login").then((r) => {
        if (r.data) {
          this.userInfo = r.data;
          this.username = r.data.username;
          this.userbalance = r.data.money;
          this.is_ban = r.data.is_rob;
        } else {
        }
      });
    },
    async playGame(gameId, origin, jdb_game_id, is_work) {
      if (this.userInfo.remark) {
        if (
          this.userInfo.remark.indexOf("模拟") != -1 ||
          this.userInfo.remark.indexOf("测试") != -1
        ) {
          if (origin != "PG") {
            return this.$message({
              message: "Contas simuladas só podem jogar jogos PG",
              type: "error",
            });
          }
        }
      }
      if (!this.username) {
        this.$parent.login();
        return;
      } else {
        //被后台禁止游戏了
        if (this.is_ban) {
          this.$toast({
            background: "#07c160",
            message:
              "Sua conta atual ainda não ativou as funções do jogo, entre em contato com seu gerente",
            duration: 5000,
          });
          return;
        }
        if (is_work == 0) {
          this.$toast({
            background: "#07c160",
            message: "Este jogo está em manutençãoe",
            duration: 5000,
          });
          return;
        }
        if (this.userbalance < 0.4) {
          return this.$parent.isShowRecharge = true;
        }
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
      // 添加本地缓存
      let localGames = localStorage.getItem("local_game_list");
      if (!localGames) {
        let json_obj = { PG: [], JDB: [], TADA: [] };
        localStorage.setItem("local_game_list", JSON.stringify(json_obj));
        localGames = localStorage.getItem("local_game_list");
      }

      localGames = JSON.parse(localGames);
      //console.log(localGames.PG);
      //return false;
      //存入本地最近游戏游戏列表中
      if (localGames[origin] && localGames[origin].indexOf(jdb_game_id) == -1) {
        localGames[origin].push(jdb_game_id);
        localStorage.setItem("local_game_list", JSON.stringify(localGames));
      }
      let reGameList = await this.getRecent(jdb_game_id, origin);
      //玩游戏前 需要先判断一下是PG的游戏还是JDB的游戏
      if (origin == "JDB") {
        //先获取一下游戏的链接
        let resp = await this.getJDBtoken(jdb_game_id);
        return this.launchJDB(resp.data);
      }

      if (origin == "TADA") {
        //先获取一下游戏的链接
        let resp = await this.getJiliUrl(gameId);
        return this.launchJDB(resp.data);
      }
      //CP游戏
      if (origin == "CP") {
        //先获取一下游戏的链接
        let resp = await this.getCPUrl(gameId);
        return this.launchJDB(resp.data);
      }
      //CP游戏
      if (origin == "PP") {
        //先获取一下游戏的链接
        let resp = await this.getPPUrl(gameId);
        return this.launchJDB(resp.data);
      }

      //PG
      if (origin == "PG") {
        this.show_game_box = true;
        var iframe = document.createElement("iframe");
        iframe.setAttribute("height", "100%");
        iframe.setAttribute("width", "100%");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("id", "myiframe");
        let l = localStorage.getItem("lang");
        let game_l = "pt";
        if (l == "pt_br") game_l = "pt";
        if (l == "en_us") game_l = "en";
        if (l == "zh_cn") game_l = "zh";
        this.game_url = await this.getPGHtml(gameId);
        if (this.game_url.data) {
          this.launchJDB(this.game_url.data.url);
        } else {
          iframe.addEventListener("load", function () {
            console.log("iframe loaded!");
          });
          var bigBox = document.getElementById("bigBox");
          bigBox.appendChild(iframe);
          iframe.contentWindow.document.open();
          iframe.contentWindow.document.write(this.game_url);
          iframe.contentWindow.document.close();
        }
      }
    },
    launchJDB(url) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("webkitallowfullscreen", "true");
      iframe.setAttribute("mozallowfullscreen", "true");
      iframe.setAttribute("src", url);
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
    },

    createIframe(content) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
      iframe.contentWindow.document.write(
        "<script>alert(1); window.location.href = " + content + ""
      );
    },
    getPGHtml(game_id) {
      // console.log(this.userInfo);return null;
      if (this.userInfo.remark) {
        if (
          this.userInfo.remark.indexOf("模拟") != -1 ||
          this.userInfo.remark.indexOf("测试") != -1
        ) {
          let _this = this;
          return new Promise((resolve, reject) => {
            Axios.post("https://test.carnaval88.com/api/demo/getPGHtml2", {
              game_id: game_id,
              user: _this.userInfo,
            })
              .then(function (response) {
                resolve(response.data);
              })
              .catch(function (error) {
                reject(error);
              });
          });
        }
      }

      return new Promise((resolve) => {
        Fetch(
          "/demo/getPGHtml2",
          { game_id: game_id, token: localStorage.getItem("token") },
          {},
          true
        ).then((res) => {
          resolve(res);
        });
      });
    },
    getJDBtoken(gameId) {
      return new Promise((resolve) => {
        Fetch("/jdb_game/jdbtoken", { id: gameId }, false, false).then(
          (res) => {
            resolve(res);
          }
        );
      });
    },
    getCPUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/cp/getGameUrl", { game_id: gameId }, false, false).then(
          (res) => {
            if (res.code == 1) resolve(res);
          }
        );
      });
    },
    getPPUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/pp/getGameUrl", { game_id: gameId }, false, false).then(
          (res) => {
            if (res.code == 1) resolve(res);
          }
        );
      });
    },
    getJiliUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/jili/game_url", { id: gameId }, false, false).then((res) => {
          if (res.code == 1) resolve(res);
          //resolve("https://www.google.com");
        });
      });
    },
    getRecent(game_id, origin) {
      return new Promise((resolve) => {
        Fetch("/game/addRecent", { game_id: game_id, origin: origin }, false, false).then(
          (res) => {
            resolve(res);
          }
        );
      });
    },
    onClickLeft() {
      this.$router.push("/");
    },
    setFavoritos(item) {
      // const { id, origin } = item
      // Toast.loading({
      //     forbidClick: true,
      // });
      // Fetch("/game/collect", { game_id: id, origin: origin }, false, false).then(
      //     (res) => {
      //         Toast.clear();
      //         this.getCollet(false);
      //     }
      // );
      const index = this.colletList.findIndex(collet => collet.id === item.id)
      if (index > -1) {
        this.colletList.splice(index, 1)
      } else {
        this.colletList.push(item)
      }
      localStorage.setItem(collectStorageKey, JSON.stringify(this.colletList))
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @primary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: @textcolor1;
}

/deep/ .van-nav-bar__title {
  color: @textcolor1;
}

// .tab_nav {
//   background-color: @secondary-color;
//   background-size: cover;
// }

/deep/ .van-tabs__wrap--scrollable {
  /* 自定义样式 */
  color: @anttextcolor;
  background: transparent;
  border-width: 1.5rem;
}

/deep/ .van-tabs__wrap--scrollable .van-tab {
  color: @textcolorf;
}

/deep/ .van-tabs__wrap--scrollable .van-tab--active {

  background-color: @ButtonColor;
}

.van-tab--active .ppl {
  color: @activityColor !important;
}

/deep/ .van-tab {
  min-width: 60px;
  height: 26px;
  border-radius: .2rem;
  // border-bottom: 0.01 solid @bodercolor;
  margin-right: .2rem;
  background: @secondary-color;
  border: 0.01rem solid @bodercolor;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  height: auto;
}

/deep/ .van-tabs__nav--line {
  padding-bottom: 0 !important;
}

/deep/ .van-tabs__line {
  bottom: 0 !important;
}

.tab_nav {
  padding-right: 15px;
  margin-top: 10px;
}

.ppl {
  font-size: .3rem;
}

.game-bg {
  display: flex;
  // align-items: center;
}

#game-right-bg {
  width: 75%;
}

.home_wrap {
  height: 100%;
  background-color: @activityColor;
}

.nav_title {
  // display: flex;
  // align-items: center;
}

.search-wrap {
  //background: rgba(250, 223, 0,0.8);
  border: 1px solid @bodercolor;
  height: 0.6rem;
  width: 95%;
  margin: 0.3rem auto 0.1rem auto;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.simg {
  font-size: 0.4rem;
  margin-right: 0.2rem;
  color: @textcolor1;
}

.nonew-list {
  width: 100%;
  text-align: center;
  margin-top: 4rem;

  img {
    width: 105px;
    height: 105px;
  }

  p {
    font-size: .3rem;
    color: @textcolor1;
  }
}

.nav_ac {
  span {
    color: #fff !important;
  }
}

.input-keyword {
  width: 70%;
  height: 100%;
  color: #fff;
  font-size: 0.32rem;
  float: left;
  text-indent: 10px;
  background: none;
  border: none;

  input {
    background: none;
    border: none;
    outline: none;
  }
}

.input-keyword::placeholder {
  color: @textcolor1
}

.show_more {
  color: @anttextcolor;
  width: 95%;
  margin: 0 auto;
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.35rem;

  div {
    height: 0.5rem;
    line-height: 0.5rem;
    color: @textcolor3;
  }
}

.game-left-item {
  width: 80%;
  color: #c7c7c7;
  background: @primary-color;
  border-radius: 0.2rem;
  // border-radius: 48%;
  margin: 0.2rem 0 0.4rem 0.2rem;
  padding: 0.02rem 0;
  text-align: center;
  height: 1.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .icon_box {
    width: 25px;
    height: 25px;
    z-index: 2;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
}

.path_ac {
  fill: @activityColor !important;
}

.nav_ac {
  color: #000;
  background-color: @ButtonColor;
}

.nav_img {
  display: block;
  width: .8rem;
  height: .8rem;
  margin: 0 auto;
}

::-webkit-scrollbar {
  display: none;
}

.game-list {
  width: 95%;
  // overflow-y: scroll;
  margin: 0 auto 0rem auto;
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
  justify-content: space-start;
}

.subgame-item {
  width: 31%;
  // height: 3.6rem;
  margin-right: .16rem;
  margin-bottom: 0.3rem;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;

  // margin-top: .3rem;
  .like_icon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 9;
  }
}

.new-list {
  position: relative;
  padding: 10px 0;
  height: 86%;
  box-sizing: border-box;

  .new_box {
    height: 100%;
    overflow-y: auto;
  }
}

.nowork {
  width: 100%;
  height: 3.7rem;
  position: relative;
  z-index: 2;
  background: rgba(0, 0, 0, 0.34);
  margin: 0 auto;
}

.game-left-item {
  svg {
    path {
      fill: @ButtonColor;
    }
  }

  &.nav_ac {
    svg {
      path {
        fill: @svgColor;
      }
    }
  }
}

.innerbox {
  width: 100%;
  height: 3.3rem;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
  box-sizing: border-box;
  // border: 1px solid #feb705;
  margin: 0 auto;
}

.subgame_item_pg_name {
  color: #fff;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  //margin: 0 auto;
  width: 100%;
  font-size: 0.3rem;
  // font-weight: 500;
  left: 0;
  bottom: -0.15rem;
  height: 1rem;
  // line-height: 0.5rem;
}

.game_name {
  width: 100%;
  text-align: center;
  position: absolute;
  height: 0.8rem;
  line-height: 0.8rem;
  bottom: 0.3rem;
  color: #fff;
  font-size: 0.45rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  //background-color: rgba(0, 0, 0,0.5);
}

.gameimg-wrap {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
}

.game-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 0.2rem;
}

.game-name {
  font-size: 0.3rem;
  color: #c7c7c7;
  text-align: center;
}

.c-sm-des {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  border-radius: 4px;
  height: 0.8rem;

  img {
    width: 1.8rem;
  }
}

.sec-title {
  color: #fff;
  font-size: 0.35rem;
  line-height: 0.6rem;
  //margin-left: 0.25rem;
}

.game-box {
  position: fixed;
  width: 100%;
  max-width: @maxWidth;
  top: 0;
  bottom: 0;
  // left: 0;
  // right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.back_to_desk {
  position: absolute;
  top: 0;
  left: 0;
  //background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  height: 1rem;
  width: 1rem;
  // display: flex;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 0.02rem solid #fff;
  color: #fff;
  font-size: 0.22rem;
  text-align: center;
  padding: 0.2rem 0.2rem;
}

.close_game_btn {
  font-size: 0.8rem;
  border-radius: 50%;
  color: #fff;
}

.geme_page {
  :deep(.van-pagination__item) {
    width: 25px;
    height: 25px;
    margin: 0 2px;
    box-sizing: border-box;
    min-width: auto;
    flex: auto;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.5);
    border: 1px solid @bodercolor;
    font-size: 12px;
    overflow: hidden;
    color: @anttextcolor;
  }

  :deep(.van-pagination__item--active) {
    background-color: @anttextcolor;
    color: @textcolor3;
    border: none;

    &::after {
      border: none;
    }
  }
}
</style>